import React, { useContext, useEffect, useState } from 'react'
import SideBarTriggerContext from '../../../context/SideBarTriggerContext';
import AuthContext from '../../../context/AuthContext';
import { Link } from 'react-router-dom';
import Notification from './notification';
import axiosClient from '../../../axios/axiosClient';
import fdoLogo from "../../../assets/images/fdo.png"
import SearchBeneficiary from './searchBeneficiary';

function Mainheader() {
    const { triggerSideBar, setTriggerSideBar } = useContext(SideBarTriggerContext);
    const { logout, user } = useContext(AuthContext);
    const [loading, setLoading] = useState([]);
    const [search, setSearch] = useState([]);
    const [toggleMenu, setToggleMenu] = useState(false);
    const [searchResult, setSearchResult] = useState([]);

    const searchBeneficiary = () =>{
      setLoading(true);
      axiosClient
      .get(`/beneficiaries/search?search=${search}`)
      .then((response) => {
        setSearchResult(response.data.data)
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
    }

    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();  
        searchBeneficiary()
      }
    };

    useEffect(() => {
      // if(search.length > 0)
      // searchBeneficiary()
    }, [search])

    return (
        <div className={`page-main-header ${triggerSideBar ? 'open' : ''}`}>
        <div className="main-header-right row">
          <div className="main-header-left col-auto px-0 d-lg-none">
            <div className="logo-wrapper"><Link href="/"><img src={fdoLogo} alt="" /></Link></div>
          </div>
          <div className="vertical-mobile-sidebar col-auto ps-3 d-none"><i className="fa fa-bars sidebar-bar"></i></div>
          <div className="mobile-sidebar col-auto ps-0 d-block">
            <div className="media-body switch-sm" onClick={()=>setTriggerSideBar(!triggerSideBar)}>
              <label className="switch"><Link ><i id="sidebar-toggle" data-feather="align-left"></i></Link></label>
            </div>
          </div>
          <div className="nav-right col p-0">
            <ul className={`nav-menus ${toggleMenu ?'open':''}`}>
              <SearchBeneficiary />
              {/* <li><a className="text-dark" href="index.html#!" onclick="javascript:toggleFullScreen()"><i data-feather="maximize"></i></a></li>
              <li className="onhover-dropdown"><a className="txt-dark" href="index.html#">
                  <h6>EN</h6></a>
                <ul className="language-dropdown onhover-show-div p-20">
                  <li><a href="index.html#" data-lng="en"><i className="flag-icon flag-icon-is"></i> English</a></li>
                  <li><a href="index.html#" data-lng="es"><i className="flag-icon flag-icon-um"></i> Spanish</a></li>
                  <li><a href="index.html#" data-lng="pt"><i className="flag-icon flag-icon-uy"></i> Portuguese</a></li>
                  <li><a href="index.html#" data-lng="fr"><i className="flag-icon flag-icon-nz"></i> French</a></li>
                </ul>
              </li> */}
              
              <li className="onhover-dropdown">
              <div className="media align-items-center">
                 <i data-feather="bell"></i>
                {/*<span className="dot"></span> */}
                <Notification />
              </div>
                
              </li>
              {/* <li><a href="index.html#"><i className="right_side_toggle" data-feather="message-circle"></i><span className="dot"></span></a></li> */}
              <li className="onhover-dropdown">
                <div className="media align-items-center">
                  <img className="align-self-center pull-right img-50 rounded-circle" src={user.photo || "../assets/images/avtar/user.jpeg"} alt="header-user" />
                  {/* <div className="dotted-animation"><span className="animate-circle"></span><span className="main-circle"></span></div> */}
                </div>
                <ul className="profile-dropdown onhover-show-div p-20">
                  <li><Link to="/edit-profile"><i data-feather="user"></i>Edit Profile</Link></li>

                  <li><Link href="#" onClick={()=> logout()}><i data-feather="log-out"></i>Logout</Link></li>
                </ul>
              </li>
            </ul>
            <div className="d-lg-none mobile-toggle pull-right" onClick={() => setToggleMenu(!toggleMenu)}><i data-feather="more-horizontal"></i></div>
          </div>
          <script id="result-template" type="text/x-handlebars-template">
            <div className="ProfileCard u-cf d-none">                        
            <div className="ProfileCard-avatar"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-airplay m-0"><path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon></svg></div>
            <div className="ProfileCard-details">
            <div  className="ProfileCard-realName"></div>
            </div>
            </div>
          </script>
          <script id="empty-template" type="text/x-handlebars-template">
            {searchResult.length === 0 && <div className="EmptyMessage">Your search turned up 0 results. </div>}
          </script>
        </div>
      </div>
    )
}

export default Mainheader
